import { render, staticRenderFns } from "./defaultTextualSection.vue?vue&type=template&id=36a77ec6&scoped=true"
import script from "./defaultTextualSection.vue?vue&type=script&lang=ts"
export * from "./defaultTextualSection.vue?vue&type=script&lang=ts"
import style0 from "./defaultTextualSection.vue?vue&type=style&index=0&id=36a77ec6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a77ec6",
  null
  
)

export default component.exports